export default __webpack_public_path__ + "static/media/logo-horizontal-blue.c6580f7c.svg";